import { MatPaginatorIntl } from '@angular/material/paginator';

const customRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length == 0 || pageSize == 0) {
        return `Page 0 of ${length}`;
    }

    const startIndex = Math.ceil(length/pageSize);

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex;

    return `Page ${page + 1} of ${endIndex}`;
};

export function customPaginatorIntl() {
    const paginatorIntl = new MatPaginatorIntl();

    paginatorIntl.itemsPerPageLabel =  'Items per page:';
    paginatorIntl.nextPageLabel = 'Nächste Seite';
    paginatorIntl.previousPageLabel = 'Vorherige Seite';
    paginatorIntl.getRangeLabel = customRangeLabel;

    return paginatorIntl;
}
